<div class="panel-complementario__seccion" [formGroup]="optionsReferenceFormGroup">
	<div class="row" style="align-items: baseline" *ngIf="showGlobalRefCheckbox">
		<div class="col-12">
			<div class="row">
				<div class="col-1 ml-5 text-center pr-1">
					<input type="checkbox" class="form-check-input" formControlName="refGlobal" (change)="changeGlobalReference()" />
				</div>
				<div class="col-9 label-control float-left">Referencia Global</div>
			</div>
		</div>
	</div>
	<div class="row mt-3">
		<div class="col-12">
			<app-references-list (referencesListEmitter)="getReferencesList($event)" [invoiceType]="currentInvoiceType" [initialReferences]="currentReferencesList"></app-references-list>
		</div>
	</div>
</div>

<ng-template #dtePagadoTemplate>
	<div class="custom-control custom-switch" [formGroup]="optionsReferenceFormGroup" *ngIf="showDtePagadoButton && canShowDtePagado && permissions.getPermission('83-20').asignado">
		<input type="checkbox" class="custom-control-input" id="dtePagado" formControlName="dtePagado" (change)="changeDtePagado($event)" />
		<label class="custom-control-label label-control" for="dtePagado">
			<span>DTE pagado</span>
		</label>
	</div>
</ng-template>

<ng-template #ivaCheckboxTemplate>
	<div class="custom-control custom-switch" [formGroup]="optionsReferenceFormGroup">
		<input type="checkbox" class="custom-control-input" id="customSwitch1" formControlName="detallesExentos" (change)="changeDetallesConIVA($event)" />
		<label class="custom-control-label label-control" for="customSwitch1">Precio detalles IVA incl.</label>
	</div>
</ng-template>

<ng-template #monedaTemplate>
	<div [formGroup]="optionsReferenceFormGroup">
		<div class="mb-5">
			<div class="custom-control custom-radio custom-control-inline">
				<input type="radio" id="radioCLP" name="tipoMoneda" class="custom-control-input" value="CLP" formControlName="tipoMoneda" (change)="onTipoMonedaChange('CLP')" [disabled]="disableCLPOption" />
				<label class="custom-control-label" for="radioCLP">CLP</label>
			</div>
			<div class="custom-control custom-radio custom-control-inline">
				<input type="radio" id="radioUSD" name="tipoMoneda" class="custom-control-input" value="USD" formControlName="tipoMoneda" (change)="onTipoMonedaChange('USD')" />
				<label class="custom-control-label" for="radioUSD">USD</label>
			</div>
			<div class="custom-control custom-radio custom-control-inline">
				<input type="radio" id="radioUF" name="tipoMoneda" class="custom-control-input" value="UF" formControlName="tipoMoneda" (change)="onTipoMonedaChange('UF')" />
				<label class="custom-control-label" for="radioUF">UF</label>
			</div>
			<div class="custom-control custom-radio custom-control-inline">
				<input type="radio" id="radioOther" name="tipoMoneda" class="custom-control-input" value="OTHER" formControlName="tipoMoneda" (change)="onTipoMonedaChange('OTHER')" />
				<label class="custom-control-label" for="radioOther">Otros</label>
			</div>
		</div>

		<div class="d-flex flex-wrap" *ngIf="!selectedForeignCurrency">
			<p class="mr-4" *ngFor="let divisa of divisasList">
				<b>{{ divisa.nombre }}:</b> <span> $ {{ divisa.valorClp | number : "1.0-2" : "es" }}</span>
			</p>
		</div>
		<p *ngIf="cargandoDivisas" class="text-muted" role="status">Cargando valores de las monedas…</p>
		<div *ngIf="!cargandoDivisas && (errorDivisas || tipoCambioPendiente)" class="alert alert-warning" role="alert">
			{{ tipoCambioPendiente ? 'Falta el valor de la moneda seleccionada. Vuelva a cargarlo o ingrese un valor mayor que cero antes de emitir.' : 'No pudimos actualizar las cotizaciones.' }}
			<button type="button" class="btn btn-link p-0 ml-2" (click)="recargarDivisas()">Volver a cargar</button>
		</div>

		<div class="moneda-otros-fields" *ngIf="optionsReferenceFormGroup.controls.tipoMoneda.value == 'OTHER'">
			<div class="moneda-otros-fields__field">
				<div class="label-control">Divisa</div>
				<ng-select [items]="monedasAduanaSource" [multiple]="false" [clearable]="false" [placeholder]="'Seleccionar tipo de moneda'" formControlName="tipoMonedaSelector" notFoundText="Moneda no encontrada" bindLabel="nombre" (change)="changeDivisaPorSelector($event)"></ng-select>
			</div>
			<div class="moneda-otros-fields__field" [formGroup]="divisasValueFormGroup">
				<div class="label-control">Valor Moneda</div>
				<input type="number" min="0" step="any" class="form-control" formControlName="newValorDivisa" (input)="onSubmit(true)" />
			</div>
		</div>
		<div class="d-flex flex-row moneda-valor-field" [formGroup]="divisasValueFormGroup" *ngIf="selectedForeignCurrency && optionsReferenceFormGroup.controls.tipoMoneda.value != 'OTHER'">
			<div class="label-control mr-2">Valor Moneda</div>
			<div class="">
				<input type="number" min="0" step="any" class="form-control" formControlName="newValorDivisa" style="max-width: 100px" (input)="onSubmit(true)" />
			</div>
		</div>
	</div>
</ng-template>
